/**
 * Forced storefront "unavailable" variants:
 * - Optional global IDs: window.WD_FORCE_UNAVAILABLE_VARIANT_IDS (layout/theme.liquid).
 * - Rules: window.WD_FORCE_UNAVAILABLE_VARIANT_RULES — e.g. Richer title + variant "3 bottles" only.
 * Must stay aligned with snippets/wd-forced-oos-effective-pipe.liquid (SSR/schema).
 */
(function () {
  window.theme = window.theme || {};

  var DEFAULT_RULES = [
    { productTitleContains: 'richer', variantTitleContains: '3 bottle' }
  ];

  var THREE_BOTTLE_RE = /\b3\s*bottles?\b/i;

  function normText(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  function variantHaystack(v) {
    if (!v || typeof v !== 'object') {
      return '';
    }
    return normText(
      [v.title, v.option1, v.option2, v.option3].filter(Boolean).join(' ')
    );
  }

  function productRootMatchesRule(productRoot, rule) {
    var needle = normText(rule.productTitleContains);
    if (!needle) return false;
    var displayTitle = productRoot.getAttribute('data-product-title') || '';
    var adminTitle = productRoot.getAttribute('data-product-admin-title') || '';
    var handle = normText(productRoot.getAttribute('data-product-handle') || '');
    if (normText(displayTitle).indexOf(needle) !== -1) return true;
    if (normText(adminTitle).indexOf(needle) !== -1) return true;
    if (handle.indexOf(needle) !== -1) return true;
    return false;
  }

  function variantMatchesRule(variantObj, rule) {
    var needle = normText(rule.variantTitleContains);
    if (!needle) return false;
    var hay = variantHaystack(variantObj);

    /* Shopify / Subscribfy use “3 bottle” singular; copy may say “3 bottles”.
       Word boundaries avoid substring hits like “13 bottles”. */
    var compactNeedle = needle.replace(/\s+/g, '');
    if (
      compactNeedle === '3bottle' ||
      compactNeedle === '3bottles' ||
      needle.indexOf('3 bottle') !== -1
    ) {
      return THREE_BOTTLE_RE.test(hay);
    }
    return hay.indexOf(needle) !== -1;
  }

  function uniqueVariantIds(ids) {
    var seen = {};
    ids.forEach(function (id) {
      var n = Number(id);
      if (!isNaN(n)) seen[n] = true;
    });
    return Object.keys(seen).map(Number);
  }

  function staticForcedIds() {
    var raw = window.WD_FORCE_UNAVAILABLE_VARIANT_IDS;
    if (!raw || !raw.length) return [];
    return raw
      .map(function (id) {
        return Number(id);
      })
      .filter(function (n) {
        return !isNaN(n);
      });
  }

  function getProductRoots() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll('[data-section-type="product"]')
    );
    if (roots.length > 0) return roots;

    var area = document.querySelector('textarea[data-variant-json]');
    var titled = document.querySelector('[data-product-title]');
    if (area && titled) return [titled];
    return [];
  }

  function ruleBasedForcedIds() {
    var rules = window.WD_FORCE_UNAVAILABLE_VARIANT_RULES;
    if (!rules || !rules.length) {
      rules = DEFAULT_RULES;
    }

    var out = [];

    getProductRoots().forEach(function (productRoot) {
      var textarea = productRoot.querySelector('textarea[data-variant-json]');
      if ((!textarea || !textarea.textContent) && document.querySelectorAll('[data-section-type="product"]').length <= 1) {
        textarea = document.querySelector('textarea[data-variant-json]');
      }
      if (!textarea || !textarea.textContent) return;

      var variants;
      try {
        variants = JSON.parse(textarea.textContent.trim());
      } catch (e) {
        return;
      }

      rules.forEach(function (rule) {
        if (!productRootMatchesRule(productRoot, rule)) {
          return;
        }
        variants.forEach(function (v) {
          if (!v) return;
          if (variantMatchesRule(v, rule)) out.push(Number(v.id));
        });
      });
    });

    return out;
  }

  theme.getForcedUnavailableVariantIds = function () {
    return uniqueVariantIds(staticForcedIds().concat(ruleBasedForcedIds()));
  };

  theme.applyForcedUnavailableToVariants = function (variants) {
    if (!variants || !variants.length) {
      return;
    }
    var ids = theme.getForcedUnavailableVariantIds();
    if (!ids.length) {
      return;
    }
    variants.forEach(function (v) {
      if (v && ids.indexOf(Number(v.id)) !== -1) {
        v.available = false;
      }
    });
  };

  function isForcedVariantId(id) {
    return theme.getForcedUnavailableVariantIds().indexOf(Number(id)) !== -1;
  }

  function requestUrl(resource) {
    if (typeof resource === 'string') return resource;
    try {
      if (typeof Request !== 'undefined' && resource instanceof Request) {
        return resource.url || '';
      }
    } catch (_) {}
    return String(resource || '');
  }

  function idsFromLikeUrlEncoded(body) {
    var out = [];
    try {
      var p =
        typeof URLSearchParams !== 'undefined' &&
        body instanceof URLSearchParams
          ? body
          : new URLSearchParams(String(body));
      p.forEach(function (val, key) {
        if (key === 'id' || /\[id\]$/.test(key)) {
          var n = Number(val);
          if (!isNaN(n)) out.push(n);
        }
      });
    } catch (_) {}
    return out;
  }

  function idsFromCartAddJson(obj) {
    var out = [];
    if (!obj || typeof obj !== 'object') return out;
    if (obj.id != null) {
      var n = Number(obj.id);
      if (!isNaN(n)) out.push(n);
    }
    if (obj.items && Array.isArray(obj.items)) {
      obj.items.forEach(function (line) {
        if (!line || line.id == null) return;
        var n2 = Number(line.id);
        if (!isNaN(n2)) out.push(n2);
      });
    }
    return out;
  }

  function idsFromPossibleJsonString(str) {
    var t = String(str || '').trim();
    if (!t || t.charAt(0) !== '{') return [];
    try {
      return idsFromCartAddJson(JSON.parse(t));
    } catch (_) {
      return [];
    }
  }

  function collectCartAddPayloadIds(body, headers) {
    if (body == null) return [];
    var ct = '';
    if (headers) {
      try {
        if (typeof Headers !== 'undefined' && headers instanceof Headers) {
          ct = (headers.get('Content-Type') || '').toLowerCase();
        } else {
          ct = (
            headers['Content-Type'] ||
            headers['content-type'] ||
            ''
          ).toLowerCase();
        }
      } catch (_) {}
    }
    if (typeof body === 'string') {
      if (ct.indexOf('application/json') !== -1) {
        return idsFromPossibleJsonString(body);
      }
      return idsFromLikeUrlEncoded(body);
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return idsFromLikeUrlEncoded(body);
    }
    return [];
  }

  function intersectsForcedVariantIds(candidateIds) {
    if (!candidateIds || !candidateIds.length) return false;
    var forced = theme.getForcedUnavailableVariantIds();
    if (!forced.length) return false;
    var set = {};
    forced.forEach(function (n) {
      set[n] = true;
    });
    for (var i = 0; i < candidateIds.length; i++) {
      if (set[Number(candidateIds[i])]) return true;
    }
    return false;
  }

  function forcedAjaxCartSoldOutResponse() {
    var description = (theme.strings && theme.strings.soldOut) || 'Sold out';
    var body = JSON.stringify({ status: 422, description: description });
    return new Response(body, {
      status: 200,
      headers: { 'Content-Type': 'application/json; charset=utf-8' }
    });
  }

  function installCartAddFetchGuard() {
    if (window.__wdForcedOosFetchPatched) return;
    window.__wdForcedOosFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (resource, init) {
      init = init || {};
      var url = requestUrl(resource);
      var method = (init.method || '').toUpperCase();
      if (
        typeof Request !== 'undefined' &&
        resource instanceof Request &&
        !init.method
      ) {
        method = ((resource.method && resource.method.toUpperCase()) || 'GET');
      }
      if (url.indexOf('/cart/add') === -1 || method !== 'POST') {
        return origFetch(resource, init);
      }
      var rawBody = init.body;
      if (rawBody == null) {
        return origFetch(resource, init);
      }
      var ids = collectCartAddPayloadIds(rawBody, init.headers);
      if (intersectsForcedVariantIds(ids)) {
        return Promise.resolve(forcedAjaxCartSoldOutResponse());
      }
      return origFetch(resource, init);
    };
  }

  function installCartAddSubmitGuard() {
    if (window.__wdForcedOosSubmitPatched) return;
    window.__wdForcedOosSubmitPatched = true;
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM') return;
        var action = (form.getAttribute('action') || '').toLowerCase();
        if (action.indexOf('/cart/add') === -1) return;
        var idEl = form.querySelector('[name="id"]');
        if (!idEl) return;
        var vid = Number(idEl.value);
        if (!isForcedVariantId(vid)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (theme.strings && theme.strings.soldOut) {
          alert(theme.strings.soldOut);
        }
      },
      true
    );
  }

  installCartAddFetchGuard();
  installCartAddSubmitGuard();

  function markPackTiles() {
    theme.getForcedUnavailableVariantIds().forEach(function (id) {
      document.querySelectorAll('.wd-new-variant-btn[data-variantid="' + id + '"]').forEach(function (el) {
        el.classList.add('disable-variant');
      });
    });
  }

  function forceVariantRowUnavailable(wrap) {
    var input = wrap.querySelector('[data-variant-input]');
    if (input) {
      input.disabled = true;
      input.classList.add('disabled');
    }
    wrap.querySelectorAll('.variant__button-label, .wd-variant__button-label').forEach(function (label) {
      label.classList.add('disabled');
    });
    var fakeBtn = wrap.querySelector('.fake-add-to-cart');
    if (fakeBtn) {
      fakeBtn.disabled = true;
      var bt = fakeBtn.querySelector('.buttons-text');
      if (bt) {
        bt.innerHTML =
          '<p style="font-size: 16px; font-weight: medium">OUT OF STOCK</p>';
      }
    }
  }

  function markWdVariantPickerRows() {
    theme.getForcedUnavailableVariantIds().forEach(function (id) {
      document
        .querySelectorAll('.variant-input[data-variant-id="' + id + '"]')
        .forEach(forceVariantRowUnavailable);
    });
  }

  /** Impulse wd custom ATC — outside Product form listeners. */
  function syncWdCustomAddToCartButton(variant) {
    document.querySelectorAll('.wd-new-custom-add-to-cart').forEach(function (btn) {
      if (!variant) {
        return;
      }
      var purchasable = variant.available && !isForcedVariantId(variant.id);
      if (purchasable) {
        btn.classList.remove('disabled');
        var existingP = btn.querySelector('p');
        var existingSpan = btn.querySelector('span');
        if (!existingP || !existingSpan) {
          btn.innerHTML = 'ADD TO CART<p hidden>.</p><span hidden>$XX</span>';
        } else {
          Array.from(btn.childNodes)
            .filter(function (node) {
              return node.nodeType === Node.TEXT_NODE;
            })
            .forEach(function (node) {
              node.remove();
            });
          btn.insertBefore(document.createTextNode('ADD TO CART'), btn.firstChild);
        }
      } else {
        btn.classList.add('disabled');
        btn.textContent = 'OUT OF STOCK';
      }
    });
  }

  function currentVariantFromProductFormJson() {
    var area = document.querySelector('textarea[data-variant-json]');
    var sel = document.querySelector('select[name="id"].product-single__variants');
    if (!area || !sel || !area.textContent) {
      return null;
    }
    try {
      var variants = JSON.parse(area.textContent.trim());
      var vid = sel.value;
      var found =
        variants.find(function (x) {
          return String(x.id) === String(vid);
        }) || null;
      if (!found) {
        return null;
      }
      var v = Object.assign({}, found);
      theme.applyForcedUnavailableToVariants([v]);
      return v;
    } catch (e) {
      return null;
    }
  }

  function guardCustomAtcDelegation() {
    document.addEventListener(
      'click',
      function (e) {
        var trigger = e.target.closest('.wd-new-custom-add-to-cart');
        if (!trigger || trigger.classList.contains('disabled')) {
          return;
        }
        var selectedBtn = document.querySelector('.wd-new-variant-btn.wd-black-border');
        if (
          selectedBtn &&
          selectedBtn.classList.contains('disable-variant')
        ) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
  }

  function init() {
    if (theme.getForcedUnavailableVariantIds().length) {
      markPackTiles();
      markWdVariantPickerRows();
    }
    guardCustomAtcDelegation();
    syncWdCustomAddToCartButton(currentVariantFromProductFormJson());
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      syncWdCustomAddToCartButton(null);
      return;
    }
    var vCopy = Object.assign({}, variant);
    theme.applyForcedUnavailableToVariants([vCopy]);
    syncWdCustomAddToCartButton(vCopy);
  });
})();
